import { render, staticRenderFns } from "./Typesets.vue?vue&type=template&id=a5ff0e6a&"
import script from "./Typesets.vue?vue&type=script&lang=js&"
export * from "./Typesets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports